import { render, staticRenderFns } from "./AddCourseManageLessons.vue?vue&type=template&id=85f59e5e&"
import script from "./AddCourseManageLessons.vue?vue&type=script&lang=ts&"
export * from "./AddCourseManageLessons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports